var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 3.83375V2.11833C11.5002 1.68708 10.9827 1.47625 10.6856 1.78292L8.00225 4.45667C7.81058 4.64833 7.81058 4.94542 8.00225 5.13708L10.676 7.81083C10.9827 8.10792 11.5002 7.89708 11.5002 7.46583V5.75042C14.6722 5.75042 17.2502 8.32833 17.2502 11.5004C17.2502 12.2575 17.1064 12.9954 16.8285 13.6567C16.6847 14.0017 16.7902 14.3946 17.0489 14.6533C17.5377 15.1421 18.3618 14.9696 18.6206 14.3275C18.9752 13.4554 19.1668 12.4971 19.1668 11.5004C19.1668 7.26458 15.736 3.83375 11.5002 3.83375ZM11.5002 17.2504C8.32808 17.2504 5.75016 14.6725 5.75016 11.5004C5.75016 10.7433 5.89391 10.0054 6.17183 9.34417C6.31558 8.99917 6.21016 8.60625 5.95141 8.3475C5.46266 7.85875 4.6385 8.03125 4.37975 8.67333C4.02516 9.54542 3.8335 10.5037 3.8335 11.5004C3.8335 15.7362 7.26433 19.1671 11.5002 19.1671V20.8825C11.5002 21.3137 12.0177 21.5246 12.3147 21.2179L14.9885 18.5442C15.1802 18.3525 15.1802 18.0554 14.9885 17.8637L12.3147 15.19C12.0177 14.8929 11.5002 15.1037 11.5002 15.535V17.2504Z",
    fill: "black",
    fillOpacity: 0.54
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/sync-icon.ed0cf6171a75b0b81e083afe6ff08a87.svg";
export { ForwardRef as ReactComponent };